import Head from "next/head";
import dynamic from "next/dynamic";
const AugmentsTierListPage = dynamic(
  () => import("../../../src/tier-list/AugmentsTierListPage.tsx"),
  {
    ssr: false,
  },
);

export default function TraitsTierList() {
  return (
    <>
      <Head>
        <title>Augments Tier List - TFT Set 17</title>
      </Head>
      <AugmentsTierListPage />
    </>
  );
}
